











import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ADL extends Vue {
  @Prop() setAdl: string;
  // adl = "";
  // @Watch("adl")
  // changeAdl(v) {
  //   this.$emit("adl", v);
  // }
  @Watch("setAdl")
  changedSetAdl(v) {
    // this.adl = v;
    this.$emit("adl", v);
  }
}
